module.exports = __webpack_public_path__ + "static/img/4.a80cc6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/4.jpg
// module id = 0Gyt
// module chunks = 1